// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const mobileType = () => {
  return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
}

const router = new Router({
  //  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return { selector: to.hash }
    }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/views/home/Index.vue'),
        },
        {
          path: 'committees',
          name: 'Committees',
          component: () => import('@/views/committees/Index.vue'),
        },
        {
          path: 'cfp',
          name: 'Call for Contribution',
          component: () => import('@/views/cfp/Index.vue'),
        },
        {
          path: 'sponsors',
          name: 'Sponsors & Supporters',
          component: () => import('@/views/sponsors/Index.vue'),
        },
        {
          path: 'newsletter',
          name: 'Newsletter',
          component: () => import('@/views/newsletter/Index.vue'),
          meta: { src: require('@/assets/pro.jpg') },
        },
        {
          path: 'past-events',
          name: 'Past Events',
          beforeEnter (to, from, next) {
            window.open('http://www.ieee-ets.org/')
          },
        },
        {
          path: 'venue',
          name: 'Venue',
          component: () => import('@/views/venue-wrapper/Index.vue'),
        },
        {
          path: 'organizing-committee',
          name: 'Organizing Committee',
          component: () => import('@/views/organizing-committee/Index.vue'),
        },
        {
          path: 'program-committee',
          name: 'Program Committee',
          component: () => import('@/views/program-committee/Index.vue'),
        },
        {
          path: 'topic-chairs',
          name: 'Topic Chairs',
          component: () => import('@/views/topic-chairs/Index.vue'),
        },
        {
          path: 'members',
          name: 'Program Committee Members',
          component: () => import('@/views/members/Index.vue'),
        },
        {
          path: 'companions',
          name: 'Companions of the Program Committee',
          component: () => import('@/views/companions/Index.vue'),
        },
        {
          path: 'key-dates',
          name: 'Key Dates',
          component: () => import('@/views/key-dates/Index.vue'),
        },
        {
          path: 'topics',
          name: 'Topics',
          component: () => import('@/views/topics/Index.vue'),
        },
        {
          path: 'submissions',
          name: 'Submissions',
          component: () => import('@/views/submissions/Index.vue'),
        },
        {
          path: 'program',
          name: 'Program',
          component: () => import('@/views/program/Index.vue'),
          children: [
            {
              path: 'submissions',
              name: 'ProgSubmissions',
              component: () => import('@/views/submissions/Index.vue'),
            },
          ],
        },
        {
          path: 'workshops',
          name: 'Workshops',
          component: () => import('@/views/workshops/Index.vue'),
        },
        {
          path: 'venice',
          name: 'Venice',
          component: () => import('@/views/venice/Index.vue'),
        },
        {
          path: 'student-activities',
          name: 'StudentWrapper',
          component: () => import('@/views/student-wrapper/Index.vue'),
        },
        {
          path: 'regional',
          name: 'Regional',
          component: () => import('@/views/regional/Index.vue'),
        },
        {
          path: 'industrial',
          name: 'Industrial',
          component: () => import('@/views/industrial/Index.vue'),
        },
        {
          path: 'sponsors',
          name: 'Sponsors',
          component: () => import('@/views/sponsors/Index.vue'),
        },
        {
          path: 'fringe-workshops',
          name: 'Fringe Workshops',
          component: () => import('@/views/fringe-workshops/Index.vue'),
        },
        {
          path: 'workshops-proposal',
          name: 'Submit a Proposal',
          component: () => import('@/views/workshops-proposal/Index.vue'),
        },
        {
          path: 'congress-center',
          name: 'Congress Center',
          component: () => import('@/views/venue/Index.vue'),
        },
        {
          path: 'hotel-rooms',
          name: 'Hotel Rooms',
          component: () => import('@/views/hotel-rooms/Index.vue'),
        },
        {
          path: 'sponsors-supporters-partners',
          name: 'Sponsors, Supporters and Partners',
          component: () => import('@/views/sponsors-wrapper/Index.vue'),
        },
        {
          path: 'partners',
          name: 'Partner Conferences',
          component: () => import('@/views/regional/Index.vue'),
        },
        {
          path: 'map',
          name: 'Partner Conferences Map',
          component: () => import('@/views/world-map-view/Index.vue'),
        },
        {
          path: 'regional-contacts',
          name: 'Regional Contacts',
          component: () => import('@/views/regional-contacts/Index.vue'),
        },
        {
          path: 'student-activities-23',
          name: 'Student Activities',
          component: () => import('@/views/student-activities/Index.vue'),
        },
        {
          path: 'bspa',
          name: 'Best Student Presentation Award',
          component: () => import('@/views/bspa/Index.vue'),
        },
        {
          path: 'student-phd-forum',
          name: 'PhD Forum 23',
          component: () => import('@/views/student-phd-forum/Index.vue'),
        },
        {
          path: 'mccluskey',
          name: 'Mc Cluskey Award',
          component: () => import('@/views/mccluskey/Index.vue'),
        },
        {
          path: 'student-activities-22',
          name: 'Student Activities ETS22',
          component: () => import('@/views/student-activities-22/Index.vue'),
        },
        {
          path: 'tss',
          name: 'Test Spring School 2023',
          component: () => import('@/views/tss/Index.vue'),
        },
        {
          path: 'visa',
          name: 'Visa',
          component: () => import('@/views/visa/Index.vue'),
        },
        {
          path: 'supporters',
          name: 'Supporters',
          component: () => import('@/views/supporters/Index.vue'),
        },
        {
          path: 'supporters-companies',
          name: 'Supporters Companies',
          component: () => import('@/views/supporters-companies/Index.vue'),
        },
        {
          path: 'submission-guidelines',
          name: 'Submission Guidelines',
          component: () => import('@/views/submission-guidelines/Index.vue'),
        },
        {
          path: 'student-phd-forum-wrap',
          name: 'PhD Forum Wrap',
          component: () => import('@/views/student-phd-forum-wrap/Index.vue'),
        },
        {
          path: 'mccluskey-wrap',
          name: 'Mc Cluskey Award Wrap',
          component: () => import('@/views/mccluskey-wrap/Index.vue'),
        },
        {
          path: 'imtr',
          name: 'IMTR',
          component: () => {
              return import('@/views/imtr/Index.vue')
          },
        },
        {
          path: 'ai-treats',
          name: 'AI-Treats',
          component: () => {
              return import('@/views/ai-treats/Index.vue')
          },
        },
        {
          path: 'e-arts',
          name: 'eARTS',
          component: () => {
              return import('@/views/e-arts/Index.vue')
          },
        },
        {
          path: 'hotel-form',
          name: 'Hotel Form',
          component: () => import('@/views/hotel-form/Index.vue'),
        },
        {
          path: 'accepted-papers',
          name: 'Accepted Papers',
          component: () => import('@/views/accepted-papers/Index.vue'),
        },
        {
          path: 'program-conference',
          name: 'Program Conference',
          component: () => import('@/views/program-conference/Index.vue'),
        },
        {
          path: 'registration-fees',
          name: 'Registration Fees',
          component: () => import('@/views/registration-fees/Index.vue'),
        },
        {
          path: 'program-calendar',
          name: 'Program Calendar',
          component: () => import('@/views/program-calendar/Index.vue'),
        },
        {
          path: 'camera-ready',
          name: 'Camera Ready',
          component: () => import('@/views/camera-ready/Index.vue'),
        },
        {
          path: 'camera-ready-scientific',
          name: 'Camera Ready Scientific',
          component: () => import('@/views/camera-ready-scientific/Index.vue'),
        },
        {
          path: 'camera-ready-special',
          name: 'Camera Ready Special',
          component: () => import('@/views/camera-ready-special/Index.vue'),
        },
        {
          path: 'camera-ready-industrial',
          name: 'Camera Ready Industrial',
          component: () => import('@/views/camera-ready-industrial/Index.vue'),
        },
        {
          path: 'accepted-industrial',
          name: 'Accepted Industrial Papers',
          component: () => import('@/views/accepted-industrial/Index.vue'),
        },
        {
          path: 'test-spring-school',
          name: 'Test Spring School',
          component: () => import('@/views/test-spring-school/Index.vue'),
        },
        {
          path: 'distinguished-service-award',
          name: 'Distinguished Service Award',
          component: () => import('@/views/dsa/Index.vue'),
        },
        {
          path: 'how-to',
          name: 'How To Reach',
          component: () => import('@/views/how-to/Index.vue'),
        },
        {
          path: 'steering',
          name: 'Steering Committee',
          component: () => import('@/views/steering/Index.vue'),
        },
        {
          path: 'posters',
          name: 'Posters',
          component: () => import('@/views/posters/Index.vue'),
        },
        {
          path: 'social-event',
          name: 'Social Event',
          component: () => import('@/views/social-event/Index.vue'),
        },
        {
          path: 'K1',
          name: 'Keynote 1',
          component: () => import('@/views/K1/Index.vue'),
        },
        {
          path: 'K2',
          name: 'Keynote 2',
          component: () => import('@/views/K2/Index.vue'),
        },
        {
          path: 'tips-tricks',
          name: 'Tips and Tricks',
          component: () => import('@/views/tips-tricks/Index.vue'),
        },
        {
          path: 'program-premium',
          name: 'Premium Program',
          component: () => import('@/views/program-premium/Index.vue'),
        },
        {
          path: 'gallery',
          name: 'gallery',
          component: () => import('@/views/gallery/Index.vue'),
        },
      ],
    },

  ],
})

export default router
